import React, { useState, useEffect } from "react";

import TextEditorReadOnly from "../../../TextEditorReadOnly/TextEditorReadOnly";

import "./styles.css";

const ApplicatedQuestionItem = props => {
  const [componentClass, setComponentClass] = useState({});
  const [correctedAnswer, setCorrectedAnswer] = useState(false);

  useEffect(() => {
    handleContainerClass();
  }, []);

  useEffect(() => {
    if (props.finished) {
      let itemDesign = "applicated-question-item-container ";
      switch (props.questionType) {
        case 4:
          if (props.userAnswer === props.itemData.check_value)
            itemDesign += "applicated-question-item-correct";
          else if (props.userAnswer !== props.itemData.check_value)
            itemDesign += "applicated-question-item-incorrect";
          break;

        default:
          if (props.userAnswer && props.itemData.check_value) {
            itemDesign += "applicated-question-item-correct";
          } else if (props.userAnswer) {
            itemDesign += "applicated-question-item-incorrect";
          } else if (props.itemData.check_value) {
            itemDesign += "applicated-question-item-true-answer";
            setCorrectedAnswer(true);
          }

          break;
      }

      setComponentClass(itemDesign);
    } else {
      handleContainerClass();
    }
  }, [
    props.finished,
    props.questionType,
    props.userAnswer,
    props.itemData.check_value
  ]);

  const handleContainerClass = () => {
    switch (props.questionType) {
      case 2:
        setComponentClass(
          "applicated-question-item-container applicated-question-item-clickable"
        );
        break;

      case 3:
        setComponentClass(
          "applicated-question-item-container applicated-question-item-clickable"
        );
        break;

      default:
        setComponentClass("applicated-question-item-container");
        setCorrectedAnswer(false);
        break;
    }
  };

  const renderItemType = questionTypeId => {
    switch (questionTypeId) {
      case 2:
        return (
          <input
            type="radio"
            checked={props.userAnswer}
            onChange={() => props.answerChanger(props.itemData.id, true)}
          />
        );

      case 3:
        return (
          <input
            type="checkbox"
            checked={props.userAnswer}
            onChange={() =>
              props.answerChanger(props.itemData.id, !props.userAnswer?.answer)
            }
          />
        );

      case 4:
        return (
          <>
            <input
              type="radio"
              checked={props.userAnswer}
              id={`true-check-item-${props.itemData.id}`}
              className="common-item-check"
              onChange={() => props.answerChanger(props.itemData.id, true)}
            />
            <label
              htmlFor={`true-check-item-${props.itemData.id}`}
              className={
                props.userAnswer
                  ? "true-or-false-item-check-true item-check-true"
                  : "true-or-false-item-check-true"
              }
            >
              <i className="fa fa-check"></i>
            </label>
            <input
              type="radio"
              checked={!props.userAnswer}
              id={`false-check-item-${props.itemData.id}`}
              className="common-item-check"
              onChange={() => props.answerChanger(props.itemData.id, false)}
            />
            <label
              htmlFor={`false-check-item-${props.itemData.id}`}
              className={
                !props.userAnswer
                  ? "true-or-false-item-check-false item-check-false"
                  : "true-or-false-item-check-false"
              }
            >
              <i className="fa fa-times"></i>
            </label>
          </>
        );

      default:
    }
  };

  return (
    <div
      className={componentClass}
      onClick={() => {
        switch (props.questionType) {
          case 2:
            props.answerChanger(props.itemData.id, true);
            break;

          case 3:
            props.answerChanger(props.itemData.id, !props.userAnswer?.answer);
            break;

          default:
            break;
        }
      }}
    >
      <section className="applicated-question-item-main-section">
        <div className="applicated-question-item-check">
          {renderItemType(props.questionType)}
        </div>
        <TextEditorReadOnly
          editorType={{ name: "item", id: 3 }}
          questionId={props.questionId}
          textContent={props.itemData.description}
        />
        {correctedAnswer && <p>Resposta Correta</p>}
      </section>
      {props.finished &&
        props.itemData.feedback &&
        props.itemData.feedback !== "" && (
          <section className="applicated-question-item-feedback-section">
            <span>feedback:</span>
            <p>{props.itemData.feedback}</p>
          </section>
        )}
    </div>
  );
};

export default ApplicatedQuestionItem;
